import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

interface Props {
  testId?: string;
  submitClaimsDateEnd?: string;
}

const LastDateToSubmitClaimsValue: React.FC<Props> = ({ testId, submitClaimsDateEnd }) => {
  const { t } = useTranslation();

  return (
    <Box data-testId={`${testId}_last-date-to-submit-claims-value_wrapper`}>
      <Text>{t('Last date to submit claims:')}</Text>
      <Text>{submitClaimsDateEnd ? dayjs(submitClaimsDateEnd).format(DEFAULT_DATE_FORMAT) : t('No deadline')}</Text>
    </Box>
  );
};

export default LastDateToSubmitClaimsValue;
